<template>
  <div>
    <v-card v-if="list.length && $vuetify.breakpoint.smAndUp">
      <div class="gallery-item">
        <div>
          <v-photoswipe-gallery 
            :isOpen="isOpenGallery"
            :options="optionsGallery" 
            :items="list" 
            @initialZoomIn="handleRemoveScale80" 
            @initialZoomOut="handleRestoreScale80"
            @resize="resizeImage"
          >
            <v-lazy-image
              :style="`object-fit: cover; height: ${props.item.height}; width: ${props.item.width}; margin-left: 5px;`"
              slot-scope="props"
              :src="props.item.src"
              :src-placeholder="props.item.placeholder"
            />
          </v-photoswipe-gallery>
        </div>
      </div>
      <v-photoswipe :isOpen="isOpen" :items="list" :options="options" @close="hidePhotoSwipe"></v-photoswipe>
      <!-- <v-btn class="lb-more" @click="showAll()">Ver todo</v-btn> -->
      <span 
        @click="showAll()" 
        class="lb-more" 
        style="cursor: pointer;"
        v-if="this.images_data.length > 8"
      ><i class="fa fa-plus" aria-hidden="true"></i></span>
    </v-card>

    <v-card v-if="list.length && $vuetify.breakpoint.smAndDown">
      <div class="gallery-item">
        <div class="text-xs-center">
          <v-photoswipe-gallery :isOpen="isOpenGallery" :options="optionsGallery" :items="list">
            <v-lazy-image
              :style="`object-fit: cover; height: 170px; width: 170px;`"
              slot-scope="props"
              :src="props.item.src"
              :src-placeholder="props.item.placeholder"
            />
          </v-photoswipe-gallery>
        </div>
      </div>
      <v-photoswipe :isOpen="isOpen" :items="list" :options="options" @close="hidePhotoSwipe"></v-photoswipe>

      <div class="text-xs-center">
        <v-btn 
          @click="showAll()"
          color="#211850"
          dark
          style="cursor: pointer;"
          v-if="this.images_data.length > 8"
          class="ver-todo-mobile"
        >Ver todo</v-btn>
      </div>
    </v-card>
  </div>
</template>  

<script>
import { PhotoSwipe, PhotoSwipeGallery } from "v-photoswipe";
import axios from "axios";
export default {
  props: {
    postId: {
      type: Number,
      required: true
    }
  },
  components: {
    "v-photoswipe": PhotoSwipe,
    "v-photoswipe-gallery": PhotoSwipeGallery
  },
  data() {
    return {
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0
      },
      optionsGallery: {
        shareButtons: [
            {id:'download', label:'Descargar imagen', url:'{{raw_image_url}}', download:true}
        ],
      },
      page: 1,
      images_data: [],
      list: [],
      showAddIcon: true,
    };
  },
  mounted() {
    this.charge();
  },
  updated(){
    // Tooltip de Photoswipe está por defecto en Chino. Con este método se setea de forma manual el atributo title de cada botón a español 
    this.titlePhotoSwipe();
  },
  methods: {
    resizeImage() {
      this.removeScale();
    },
    handleRemoveScale80() {
      this.isOpen = true;
      this.removeScale();
    },
    handleRestoreScale80() {
      this.isOpen = false;
      this.restoreScale();
    },
    removeScale() {
      let routerView = document.getElementsByClassName('tff-routerview')[0];

      if (routerView) {
        routerView.style.setProperty("transform", "");
        routerView.style.setProperty("transform-origin", "");
        routerView.style.setProperty("transform-bottom", "");
      }
    },
    restoreScale() {
      let routerView = document.getElementsByClassName('tff-routerview')[0];

      if (routerView) {
        routerView.style.setProperty("transform", "scale(0.8)");
        routerView.style.setProperty("transform-origin", "center top");
        routerView.style.setProperty("transform-bottom", "-100px");
      }
    },
    showPhotoSwipe(index) {
      this.isOpen = true;
      this.$set(this.options, "index", index);
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    },
    charge() {
      let api = `${process.env.VUE_APP_API_URL}/posts/gallery`;
      axios
        .get(api, { params: { page: this.page, post_id: this.postId } })
        .then(({ data }) => {
          this.images_data = data.hits;
          this.list = this.images_data.slice(0, 8);
        });
    },
    titlePhotoSwipe(){
      let btnShare = document.getElementsByClassName('pswp__button pswp__button--share')[0];
      let btnClose = document.getElementsByClassName('pswp__button pswp__button--close')[0];
      let btnFullScreen = document.getElementsByClassName('pswp__button pswp__button--fs')[0];
      let arrowLeft = document.getElementsByClassName('pswp__button pswp__button--arrow--left')[0];
      let arrowRight = document.getElementsByClassName('pswp__button pswp__button--arrow--right')[0];
      let btnZoom = document.getElementsByClassName('pswp__button pswp__button--zoom')[0];
      
      if (btnShare) btnShare.title = "Compartir";
      if (btnClose) btnClose.title = "Cerrar (Esc)";
      if (btnFullScreen) btnFullScreen.title = "Pantalla Completa";
      if (arrowLeft) arrowLeft.title = "Anterior";
      if (arrowRight) arrowRight.title = "Siguiente";
      if (btnZoom) btnZoom.title = "Zoom";
    },
    showAll() {
      this.showAddIcon = false
      const span = document.getElementsByClassName('lb-more')[0];
      const button = document.getElementsByClassName('ver-todo-mobile')[0];

      if (span) span.remove();
      if (button) button.remove();
      this.list = this.images_data;
    },
  }
};
</script>

<style scoped>
img {
  display: inline-block;
  /* width: 280px;
  height: 280px; */
  margin-left: 5px;
  object-fit: cover;
  cursor: pointer;
}
.v-lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
.decorated-momentos {
  overflow: hidden;
  text-align: center;
}
.decorated-momentos > span {
  position: relative;
  display: inline-block;
}
.decorated-momentos > span:before,
.decorated-momentos > span:after {
  content: "";
  position: absolute;
  top: 50%;
  border-bottom: 1px solid;
  width: 155%; /* half of limiter*/
  margin: 0 90px;
}
.decorated-momentos > span:before {
  right: 80%;
}
.decorated-momentos > span:after {
  left: 80%;
}
</style>